import React, { useEffect, useState } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { Provider } from "react-redux";
import { LDProvider } from "launchdarkly-react-client-sdk";
import store from "./store";
import AccountMspa from "./pages/Account/AccountMspa";
import ProjectsMspa from "./pages/Projects/ProjectsMspa";
import ClientsMspa from "./pages/Admin/Clients/ClientsMspa";
import AccountsMspa from "./pages/Site/Accounts/AccountsMspa";
import TeamsMspa from "./pages/Admin/Teams/TeamsMspa";
import LaunchDarklyProvider from "./common/launchDarkly/LaunchDarklyProvider";
import SurveyMspa from "./pages/Surveys/SurveyMspa";
import { Dashboard } from "./pages/DashboardV2";
import { ThemeProvider } from "@emotion/react";
import theme from "./themes/theme";
import AuthorizationProvider from "./common/providers/AuthorizationProvider";
import Products from "./pages/Products";
import ConnectedApps from "./pages/Admin/ConnectedApps";
import { TravelAndExpenseV2Mspa } from "./pages/TravelAndExpenseV2";
import { GovernanceV2Mspa } from "./pages/GovernanceV2";
import { VendorQuotesV2Mspa } from "./pages/VendorQuotesV2";
import { ProfessionalServicesMspa } from "./pages/Admin/ProfessionalServices";
import { DocumentTemplatesMspa } from "./pages/Admin/DocumentTemplates";
import { ProjectVersionsV2Mspa } from "./pages/ProjectVersionsV2";
import CollaboratorsV2 from "./pages/CollaboratorsV2/CollaboratorsV2";
import Standards from "./pages/Projects/ServicesV2/Standards";
import Blueprints from "./pages/Projects/ServicesV2/Blueprints";
import VendorsV2Mspa from "./pages/Admin/VendorsV2/VendorsV2Mspa";
import ProductsV2Mspa from "./pages/Admin/ProductsV2/ProductsV2Mspa";
import ResourcesV2Mspa from "./pages/ResourcesV2/ResourcesV2Mspa";
import ProjectSurveysMspa from "./pages/ProjectSurveysV2/ProjectSurveysMspa";
import { Show } from "./pages/ProjectServicesV2/Show";
import CustomerSummaryV2 from "./pages/CustomerSummaryV2/CustomerSummaryV2";

const App = (props) => {
  const { account_slug, project_id } = props;

  if (!account_slug || account_slug === "" || account_slug === undefined) {
    throw new Error("!! Extreme danger !! account_slug is required");
  }

  return (
    <Provider store={store}>
      <AuthorizationProvider account_slug={account_slug}>
        <ThemeProvider theme={theme}>
          <LDProvider
            clientSideID={
              process.env.REACT_APP_LAUNCHDARKLY_CLIENT_ID || "dummyclient"
            }
          >
            <LaunchDarklyProvider
              accountSlug={account_slug}
              clientSideID={
                process.env.REACT_APP_LAUNCHDARKLY_CLIENT_ID || "dummyclient"
              }
            >
              <Router>
                <Routes>
                  <Route path="/home" element={<Dashboard {...props} />} />
                  <Route path="/users/*" element={<AccountMspa {...props} />} />
                  <Route
                    path="/projects/:id/project_materials/*"
                    element={<Products {...props} />}
                  />
                  <Route
                    path="/projects/*"
                    element={<ProjectsMspa {...props} />}
                  />
                  <Route
                    path="/surveys/*"
                    element={<SurveyMspa {...props} />}
                  />
                  <Route
                    path="/admin/account_connections/*"
                    element={<ConnectedApps {...props} />}
                  />
                  <Route
                    path="/admin/teams/*"
                    element={<TeamsMspa {...props} />}
                  />
                  <Route
                    path="/admin/clients/*"
                    element={<ClientsMspa {...props} />}
                  />
                  <Route
                    path="/site/accounts/*"
                    element={<AccountsMspa {...props} />}
                  />
                  <Route
                    path="/projects/:id/project_expenses/*"
                    element={<TravelAndExpenseV2Mspa {...props} />}
                  />
                  <Route
                    path="/projects/:id/sow_outcome/*"
                    element={<CustomerSummaryV2 {...props} />}
                  />
                  <Route
                    path="/projects/:id/project_governances/*"
                    element={<GovernanceV2Mspa {...props} />}
                  />
                  <Route
                    path="/projects/:id/quotes/*"
                    element={<VendorQuotesV2Mspa {...props} />}
                  />
                  <Route
                    path="/admin/tasks/*"
                    element={
                      <ProfessionalServicesMspa
                        {...props}
                        serviceType="professional_services"
                      />
                    }
                  />
                  <Route
                    path="/admin/managed_services/*"
                    element={
                      <ProfessionalServicesMspa
                        {...props}
                        serviceType="managed_services"
                      />
                    }
                  />
                  <Route
                    path="/admin/document_templates/*"
                    element={<DocumentTemplatesMspa {...props} />}
                  />
                  <Route
                    path="/projects/:id/project_versions/*"
                    element={<ProjectVersionsV2Mspa {...props} />}
                  />
                  <Route
                    path="/projects/:id/project_collaborators/*"
                    element={<CollaboratorsV2 {...props} />}
                  />
                  <Route
                    path="/projects/:id/standard_tasks/new"
                    element={<Standards {...props} />}
                  />
                  <Route
                    path="/projects/:id/task_blueprints/new"
                    element={<Blueprints {...props} />}
                  />
                  <Route
                    path="/admin/vendors/*"
                    element={<VendorsV2Mspa {...props} />}
                  />
                  <Route
                    path="/admin/materials/*"
                    element={<ProductsV2Mspa {...props} />}
                  />
                  <Route
                    path="projects/:id/project_surveys/*"
                    element={<ProjectSurveysMspa {...props} />}
                  />
                  <Route
                    path="/projects/:id/project_resources/*"
                    element={<ResourcesV2Mspa {...props} />}
                  />
                  <Route
                    path="/projects/:id/project_editor/*"
                    element={
                      <Show service_type="professional_services" {...props} />
                    }
                  />
                  <Route
                    path="/projects/:id/managed_service/*"
                    element={
                      <Show service_type="managed_services" {...props} />
                    }
                  />
                </Routes>
              </Router>
            </LaunchDarklyProvider>
          </LDProvider>
        </ThemeProvider>
      </AuthorizationProvider>
    </Provider>
  );
};

export default App;
